<template>
<div class="chapter">
<div class="inner_page">
<p class="epi-brk" id="epi"> </p>
<p class="ep"><span class="epub-i">There never was a man who holding pain within himself had not seen God and known eternity and walked from them alone … or else, seeing beauty, thirsted after it as some life-giving force to which he must give his whole abandon.</span></p>
<p class="epc"><span class="epub-sc">—</span>M<span class="epub-sc">ILLICENT </span>R<span class="epub-sc">OGERS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?9428a036